var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-back mb-2",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left"}}),_vm._v(" "+_vm._s(_vm.$t('generic.back', 'Back'))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }